/* ============================================================
   ENJIN BAHASA — SESAAT v3.9 (Melayu / English)
   ============================================================
   Corak yang SAMA dengan suis tema Terang/Gelap: pilihan
   disimpan PER-BROWSER dalam localStorage (kunci `sesaat_lang`),
   BUKAN Firestore. Tiada kos bacaan, tiada perubahan
   firestore.rules, dan browser lain kekal dengan pilihan
   masing-masing.

   ⭐ BAHASA MELAYU IALAH LALAI (keputusan user 2026-08-27,
      menggantikan keputusan English 2026-08-16). Tiada pilihan
      tersimpan → Melayu. Sebabnya ditemui pada halaman harga
      yang baru dilancarkan: tajuknya Melayu tetapi kotak harga
      keluar English, dan halaman jualan awam TIADA butang tukar
      bahasa — jadi pelawat Malaysia tersekat dengan English pada
      skrin yang sepatutnya menjual kepada mereka.
      Terma kerja (Flow, run, generate, browser, module, prompt,
      extension, cloud, GPT, Gems) KEKAL English dalam kedua-dua
      kamus — lihat TERMA_JANGAN_TERJEMAH di bawah.
      Pelanggan yang mahu English boleh menukar di Settings → Paparan.

   ⚠️ JANGAN CAMPURKAN DUA PEMALAR DI BAWAH — ia dua benda
      berlainan, dan menyatukannya semula akan memecahkan
      sandaran secara SENYAP:

        BAHASA_LALAI    = bahasa untuk pengguna yang belum
                          pernah memilih apa-apa. Ia soalan
                          PRODUK, dan ia boleh berubah.

        BAHASA_SANDARAN = kamus yang dirujuk bila sesuatu kunci
                          tiada dalam bahasa aktif. Ia mesti
                          menunjuk kepada kamus yang DIJAMIN
                          lengkap — iaitu ms.js, kerana setiap
                          ayat produk lahir dalam Bahasa Melayu
                          dahulu sebelum diterjemah.

      Kalau kedua-duanya ditetapkan kepada 'en', kunci yang
      tertinggal dalam en.js tidak lagi ada tempat untuk jatuh:
      cari() akan memulangkan nama kunci mentah
      ("settings.profile.email") terus kepada pelanggan.

   ── CARA GUNA DALAM KOMPONEN ────────────────────────────────
       import { useT } from '../i18n';

       const t = useT();
       <h1>{t('settings.account.title')}</h1>
       <p>{t('settings.storage.of', { jumlah: '2 GB' })}</p>

   ── KENAPA PROVIDER DUDUK DALAM FAIL LAIN ───────────────────
   `LangProvider` ada dalam ./LangProvider.jsx, bukan di sini.
   Peraturan lint `react-refresh/only-export-components` melarang
   satu fail mengeksport komponen DAN bukan-komponen serentak.
   Memisahkannya bermakna hampir semua fail hanya perlu satu
   import kemas (`from '../i18n'`), dan hanya main.jsx yang
   mengimport provider.

   ── PERATURAN KUNCI (WAJIB IKUT) ────────────────────────────
   1. Kunci = huruf kecil, bertitik, bermula dengan nama
      halaman/ruang: `settings.*`, `dashboard.*`, `sidebar.*`.
      Kunci RATA (flat), bukan bersarang — senang di-grep,
      senang digabung, senang nampak bila hilang.
   2. Setiap kunci WAJIB wujud dalam ms.js DAN en.js. Kunci
      tertinggal dalam en.js tidak memecahkan halaman (ia jatuh
      balik ke Melayu), tetapi pelanggan English akan nampak
      ayat Melayu terselit — anggap ia pepijat.
   3. JANGAN cantum ayat daripada serpihan (`t('a') + ' ' + t('b')`).
      Susunan perkataan berbeza antara bahasa. Guna satu kunci
      penuh dengan pemboleh ubah: `t('x.y', { nama })`.
   4. Nombor/tarikh/nama orang TIDAK masuk kamus — hantar
      sebagai pemboleh ubah.
   5. Terma dalam TERMA_JANGAN_TERJEMAH (bawah) KEKAL SAMA
      dalam kedua-dua bahasa. Lihat senarai itu sebelum menulis
      mana-mana ayat baharu.
   ============================================================ */

import { createContext, useContext } from 'react';
/* Sambungan .js ditulis eksplisit supaya kamus boleh diuji terus
   dengan `node` (skrip semakan keselarasan kunci) tanpa melalui
   Vite. Vite menerima kedua-dua bentuk. */
import ms from './ms.js';
import en from './en.js';

export const KUNCI_SIMPAN = 'sesaat_lang';

/* Bahasa untuk pengguna yang belum pernah memilih. Soalan PRODUK.
   Ditukar 'en' → 'ms' pada 2026-08-27; baca nota di kepala fail.
   ⛔ JANGAN tetapkan BAHASA_SANDARAN kepada 'en' — dua-dua 'en'
      memecahkan sandaran secara senyap (nota panjang di atas). */
export const BAHASA_LALAI = 'ms';

/* Kamus rujukan bila kunci tiada dalam bahasa aktif. Ia MESTI
   menunjuk kepada kamus yang dijamin lengkap — baca nota panjang
   di kepala fail sebelum menukarnya. */
export const BAHASA_SANDARAN = 'ms';

/* ⛔ TERMA YANG TIDAK PERNAH DITERJEMAH — tulis SAMA dalam ms.js
   dan en.js (arahan user 2026-08-16).

   Sebabnya bukan gaya, tetapi ketepatan: ini nama produk dan
   nama skrin SEBENAR yang pelanggan akan cari. "Flow" ialah
   Google Labs Flow — menterjemahkannya menjadi "Aliran" bermakna
   pelanggan mencari butang yang memang tidak wujud, dan arahan
   dalam group WhatsApp tidak lagi sepadan dengan skrin.

   Ia memang muncul di TENGAH ayat Melayu. Itu betul, bukan
   terlupa diterjemah:
     "Sila Run Flow sebelum memuat naik video."             ✅
     "Sila Jalankan Aliran sebelum memuat naik video."      ❌ */
export const TERMA_JANGAN_TERJEMAH = [
    /* Nama produk / platform */
    'Flow', 'Google Flow', 'TikTok', 'TikTok Studio', 'Chrome', 'Google',
    'WhatsApp', 'Billplz', 'SESAAT',
    /* Nama modul SESAAT */
    'AI8SAAT', 'AI16SAAT', 'Home Niche', 'GOYANG', 'Smart Custom',
    'FLOWNITY', 'Flow Ultra', 'Pro Studio',
    /* Nama ciri/skrin yang pelanggan sebut dalam English */
    'run', 'generate', 'scrape', 'prompt', 'collection', 'set',
    'extension', 'browser', 'workspace', 'Cloud', 'template',
    'module', 'video', 'project', 'scene', 'thumbnail', 'affiliate',
];

/* ⚠️ PENGECUALIAN — terma ini KELIHATAN teknikal tetapi SESAAT
   memang sudah menterjemahkannya sejak hari pertama. Kekalkan
   bentuk Melayu yang sedia ada; jangan "betulkan" ia kepada
   English atas nama konsistensi, kerana pelanggan sudah biasa
   membacanya begini:
       upload   → "Muat naik"
       download → "Muat turun"
       install  → "pasang" / "Cara pasang"
       delete   → "Padam"
   Kalau ragu tentang sesuatu perkataan: buka ms.js dan lihat
   bagaimana ia SUDAH ditulis, kemudian ikut. Kamus itu ialah
   suara produk, bukan senarai ini. */

/* Senarai bahasa pada pemilih di Settings → Paparan. Yang lalai
   didahulukan. `label` sengaja ditulis dalam bahasa masing-masing
   (endonim) — pelanggan yang tersalah pilih bahasa asing masih
   boleh mengenali bahasanya sendiri untuk patah balik. */
/* `kod` = label pendek untuk ruang sempit (pil suis bahasa pada kepala
   halaman, tile pemilih di Settings). Ia SENGAJA berbeza daripada `id`:
   id 'ms' ialah kod bahasa piawai yang disimpan dan dijadikan kunci
   kamus, tetapi pelanggan Malaysia mengenali bahasanya sebagai "BM",
   bukan "MS" (arahan user 2026-08-16). Papar `kod`, simpan `id`.

   ⚠️ Setiap tempat yang memapar nama bahasa WAJIB mengambilnya dari
      senarai ini — jangan tulis "EN"/"BM" terus dalam komponen. Dua
      salinan bermakna satu daripadanya akan tertinggal bila bahasa
      ketiga ditambah, atau bila label ditukar semula. */
export const SENARAI_BAHASA = [
    { id: 'en', kod: 'EN', label: 'English', nota: 'Inggeris' },
    { id: 'ms', kod: 'BM', label: 'Bahasa Melayu', nota: 'Malay' },
];

const KAMUS = { ms, en };

export const bahasaSah = (v) => v === 'ms' || v === 'en';

/* Dibaca oleh main.jsx sebelum React dimulakan (untuk mengecap
   atribut <html lang>) dan oleh provider sebagai keadaan awal. */
export function bacaBahasaTersimpan() {
    try {
        const v = localStorage.getItem(KUNCI_SIMPAN);
        return bahasaSah(v) ? v : BAHASA_LALAI;
    } catch {
        /* storan disekat (mod privasi) — kekal pada lalai */
        return BAHASA_LALAI;
    }
}

/* Ganti {nama} dengan nilai sebenar. Pemboleh ubah yang tiada
   dibiarkan sebagaimana adanya supaya kesilapan nampak pada
   skrin semasa pembangunan, bukan jadi ruang kosong senyap. */
function isiPembolehUbah(teks, vars) {
    if (!vars || typeof teks !== 'string') return teks;
    return teks.replace(/\{(\w+)\}/g, (padanan, nama) =>
        vars[nama] === undefined || vars[nama] === null ? padanan : String(vars[nama]));
}

export function cari(bahasa, kunci, vars) {
    const utama = KAMUS[bahasa]?.[kunci];
    if (typeof utama === 'string') return isiPembolehUbah(utama, vars);

    /* Sandaran: kunci belum diterjemah → pulangkan versi daripada
       kamus INDUK (ms.js), bukan daripada bahasa lalai. Dua benda
       berbeza sejak English jadi lalai — kalau ini menunjuk kepada
       bahasa lalai, kunci yang hilang dalam en.js akan mencari
       dirinya sendiri dan pelanggan nampak nama kunci mentah. */
    const sandaran = KAMUS[BAHASA_SANDARAN]?.[kunci];
    if (typeof sandaran === 'string') return isiPembolehUbah(sandaran, vars);

    /* `?.` sengaja: import.meta.env hanya wujud di bawah Vite. Tanpa
       pagar ini modul meletup bila dimuatkan oleh node biasa (skrip
       semakan kamus, ujian) — dan amaran ini sepatutnya membantu,
       bukan menjatuhkan pemanggilnya. */
    if (import.meta.env?.DEV) {
        console.warn(`[i18n] Kunci tiada dalam kamus: "${kunci}"`);
    }
    return kunci;
}

export const KonteksBahasa = createContext(null);

/* ⛔ SENGAJA TIDAK MELEMPAR RALAT bila provider tiada. Komponen
   yang dipaparkan di luar pokok React utama (cth skrin ralat
   Sentry, atau ujian unit) masih perlu memaparkan teks — tanpa
   provider ia merosot dengan tenang, bukan jadi skrin putih.

   Ia membaca terus daripada localStorage supaya pelanggan yang
   sudah memilih Bahasa Melayu tidak tiba-tiba dilempar ke English
   pada skrin ralat — iaitu saat mereka paling perlu memahami apa
   yang tertulis. */
function sandaranTanpaProvider() {
    const bahasa = bacaBahasaTersimpan();
    return {
        lang: bahasa,
        setLang: () => { },
        t: (kunci, vars) => cari(bahasa, kunci, vars),
    };
}

export function useLang() {
    return useContext(KonteksBahasa) || sandaranTanpaProvider();
}

export function useT() {
    return useLang().t;
}
